import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import React from 'react';
import { useThemeColor } from '../Theme';
import { Breadcrumb } from './Breadcrumb';
import { StyledSeparator } from './Breadcrumb.styled';
import { BreadcrumbOverflow } from './BreadcrumbOverflow';
import { StyledBreadcrumbItem, StyledBreadcrumbNav, StyledOrderedList } from './Breadcrumbs.styled';
export function Breadcrumbs(_ref) {
  var breadcrumbs = _ref.breadcrumbs,
    maxItems = _ref.maxItems;
  var textIconColor = useThemeColor('primaryText');
  var _breadcrumbs$reduceRi = breadcrumbs.reduceRight(function (acc, breadcrumb) {
      if (maxItems && acc.visibleBreadcrumbs.length === maxItems) {
        return _objectSpread(_objectSpread({}, acc), {}, {
          hiddenBreadcrumbs: [].concat(_toConsumableArray(acc.hiddenBreadcrumbs), [breadcrumb])
        });
      }
      return _objectSpread(_objectSpread({}, acc), {}, {
        visibleBreadcrumbs: [breadcrumb].concat(_toConsumableArray(acc.visibleBreadcrumbs))
      });
    }, {
      hiddenBreadcrumbs: [],
      visibleBreadcrumbs: []
    }),
    hiddenBreadcrumbs = _breadcrumbs$reduceRi.hiddenBreadcrumbs,
    visibleBreadcrumbs = _breadcrumbs$reduceRi.visibleBreadcrumbs;
  return /*#__PURE__*/React.createElement(StyledBreadcrumbNav, {
    "aria-label": "Breadcrumb"
  }, /*#__PURE__*/React.createElement(BreadcrumbOverflow, {
    breadcrumbs: hiddenBreadcrumbs
  }), /*#__PURE__*/React.createElement(StyledOrderedList, null, visibleBreadcrumbs.map(function (breadcrumb, index) {
    var isLastBreadcrumb = index === visibleBreadcrumbs.length - 1;
    return /*#__PURE__*/React.createElement(StyledBreadcrumbItem, {
      key: index,
      forceEllipsisOnActive: breadcrumb.forceEllipsisOnActive
    }, /*#__PURE__*/React.createElement(Breadcrumb, _extends({
      isActive: isLastBreadcrumb
    }, breadcrumb)), !isLastBreadcrumb && /*#__PURE__*/React.createElement(StyledSeparator, {
      color: textIconColor
    }));
  })));
}